import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {classNames} from './support/classnames';

interface OwnProps {
    visible: boolean;
    forced?: boolean;
    wide?: boolean;
    fluid?: boolean;
    onHide: () => any;
    onShow?: () => any;
}

export default class Modal extends React.Component<OwnProps> {
    private ref: any = null;
    private unmounted: boolean = false;

    public componentDidUpdate(prevProps: OwnProps) {
        if (this.props.visible && !prevProps.visible) {
            $(this.ref).modal('show');
        } else if (!this.props.visible && prevProps.visible) {
            $(this.ref).modal('hide');
        }
    }

    public componentDidMount() {
        const modal: any = ($(this.ref) as any).modal({
            show: false,
            backdrop: this.props.forced === true ? 'static' : true,
        });
        modal.on('hide.bs.modal', () => {
            if (this.props.onHide && !this.unmounted) {
                this.props.onHide();
            }
        });
        modal.on('shown.bs.modal', () => {
            if (this.props.onShow && !this.unmounted) {
                this.props.onShow();
            }
        });

        if (this.props.visible) {
            $(this.ref).modal('show');
        }
    }

    public componentWillUnmount() {
        this.unmounted = true;
        $(this.ref).modal('hide');
    }

    public render() {
        const mountingPoint = document.getElementById('modal');
        if (mountingPoint === null) {
            return null;
        }

        return ReactDOM.createPortal(
            <div className={classNames('modal', 'fade')} ref={(ref) => (this.ref = ref)}>
                <div
                    className={classNames('modal-dialog', {
                        'modal-lg': this.props.wide,
                        'modal-fluid': this.props.fluid,
                    })}
                    role="document"
                >
                    <div className="modal-content">{this.props.visible ? this.props.children : null}</div>
                </div>
            </div>,
            mountingPoint,
        );
    }
}
